import { Link } from "react-router-dom";

const quickLinks = [
  { to: "/list", label: "全部韩漫" },
  { to: "/shuyuan", label: "免费书源推荐" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
];

export default function Footer() {
  return (
    <footer className="mt-auto w-full bg-background-200/60">
      <div className="mx-auto w-full px-4 md:px-6 py-12">
        <div className="flex flex-col gap-8 md:flex-row md:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-ghost-smile-fill text-lg" />
              </span>
              <span className="heading-font text-xl font-bold text-foreground-950">韩漫大全</span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              聚合多个免费韩漫在线阅读站资源，帮你解决好看的韩漫大全哪个网站有的问题，推荐稳定收藏站点，随时打开随时看，追更不迷路。
            </p>
          </div>

          <div className="flex flex-col gap-2">
            <h3 className="text-sm font-bold text-foreground-950">快速导航</h3>
            {quickLinks.map((l) => (
              <Link key={l.to} to={l.to} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                {l.label}
              </Link>
            ))}
          </div>

          <div className="flex flex-col gap-2">
            <h3 className="text-sm font-bold text-foreground-950">热门题材</h3>
            {["热血战斗", "奇幻冒险", "恋爱治愈", "悬疑惊悚", "重生逆袭"].map((c) => (
              <Link
                key={c}
                to={`/list?cat=${encodeURIComponent(c)}`}
                className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
              >
                {c}
              </Link>
            ))}
          </div>

          <div className="flex flex-col gap-2">
            <h3 className="text-sm font-bold text-foreground-950">联系与反馈</h3>
            <p className="text-sm text-foreground-600">邮箱：hi@hanman-daquan.example</p>
            <p className="text-sm text-foreground-600">本站仅聚合公开书源信息，版权归原作者所有</p>
            <p className="text-sm text-foreground-600">请合理使用，支持正版创作</p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-300/60 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">© 2026 韩漫大全 · 好看韩漫在线阅读与免费网站推荐平台</p>
          <p className="text-xs text-foreground-500">收藏本站，追更好看韩漫不迷路</p>
        </div>
      </div>
    </footer>
  );
}